// ======================================================================
// File Name       : email
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { MODE, RETURN_MAX_NUM } from '../constants';
import * as ActionTypes from '../constants/actionTypes/email';
import { USER_TYPE } from '../constants/UserConstants';
import { validEmail } from '../utils/ValidateUtils';

const INITIAL_STATE = {
  searchUserCondition: { userType: USER_TYPE.STUDENT, userAttributeKeyNum: 1 },
  storeSearchUserCondition: { userType: USER_TYPE.STUDENT, userAttributeKeyNum: 1 },
  searchUserResult: {
    startPosition: 0,
    searched: false,
    recordNum: 0,
    bySecernId: {},
    allSecernIds: [],
  },

  editType: MODE.EDIT_MODE,

  editingUser: {},

  userList: {},
  storedUserList: {
    bySecernId: {},
    allSecernIds: [],
  },

  checkedUser: {
    bySecernId: {},
    allSecernIds: [],
  },

  checkedUserOnPage: {
    bySecernId: {},
    allSecernIds: [],
  },

  isAddRemoveAllUser: false,
  groupList: [],
  selectedGroupList: [],
  emailReceiverList: [],

  receiveMails: {
    allMailIds: [],
    byMailIds: {},
  },
  emailList: [],
  allGroup: [],
  emailInfo: {},
  recordNum: 0,
  allUserByEmail: [],
  allUserAttribute: [],
  allUserGroupRelation: [],
  allGroupRelation: [],
  allUserList: [],
  emailReceiverSaveKey: '',
  reservedEmailList: [],
  reservedEmailInfo: {},
  isUsedTemplate: 0,
  courseName: '',
};

export default function email(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ActionTypes.EMAIL_RECEIVE_STRUCTURE_LIST:
      return receiveStructureList(state, action);

    case ActionTypes.EMAIL_RESET_INIT_DATA:
      return resetInitData(state);

    case ActionTypes.EMAIL_RESET_SEARCH_USER_DATA:
      return resetSearchUserData(state);

    case ActionTypes.EMAIL_RESET_SEARCH_USER_CONDITION:
      return resetSearchUserCondition(state);

    case ActionTypes.EMAIL_RECEIVE_USER_SEARCH_RESULT:
      return receiveUserSearchUserResult(state, action);

    case ActionTypes.EMAIL_RECEIVE_ALL_USER_SEARCH_RESULT:
      return receiveAllUserSearchUserResult(state, action);

    case ActionTypes.EMAIL_CHECK_ALL_USER:
      return checkAllUser(state);

    case ActionTypes.EMAIL_ADD_REMOVE_USER:
      return addRemoveUser(state, action);

    case ActionTypes.EMAIL_ADD_SELECTED_USER:
      return addSelectedUser(state, action);

    case ActionTypes.EMAIL_REMOVE_USER:
      return removeUser(state, action);

    case ActionTypes.EMAIL_REMOVE_ALL_USER:
      return removeAllUser(state, action);

    case ActionTypes.EMAIL_RECEIVE_SEARCH_CONDITION:
      return receiveSearchUserCondition(state, action);

    case ActionTypes.EMAIL_ADD_GROUP:
      return addGroup(state, action);

    case ActionTypes.EMAIL_DEL_GROUP:
      return removeGroup(state, action);

    case ActionTypes.EMAIL_REMOVE_SELECTED_USER:
      return removeSelectedUser(state);

    case ActionTypes.RECEIVE_USERS_FROM_COURSE_HISTORY:
      return receiveUsersFromCourseHistory(state, action);

    case ActionTypes.GET_EMAIL_LIST:
      return getEmailList(state, action);

    case ActionTypes.GET_EMAIL_DETAIL:
      return getEmailDetail(state, action);

    case ActionTypes.ALL_USER_RECEIVED_BY_EMAIL:
      return getAllUserReceivedByEmail(state, action);

    case ActionTypes.ALL_USER_ATTRIBUTE_RECEIVED:
      return getAllUserAttributeReceived(state, action);

    case ActionTypes.ADD_USER_TO_LIST_BY_EMAIL:
      return addUserToListByEmail(state, action);

    case ActionTypes.ALL_USER_GROUP_RELATION_RECEIVED:
      return getAllUserGroupRelationReceived(state, action);

    case ActionTypes.ALL_GROUP_RELATION_RECEIVED:
      return getAllGroupRelationReceived(state, action);

    case ActionTypes.ALL_USER_LIST_RECEIVED:
      return getAllUserListReceived(state, action);

    case ActionTypes.SAVE_RECEIVER:
      return saveReceiver(state, action);

    case ActionTypes.SAVE_EMAIL_RECEIVER_SAVE_KEY:
      return saveEmailReceiverSaveKey(state, action);

    case ActionTypes.BACKUP_INIT_STATE:
      return backupInitState(state);

    case ActionTypes.RESTORE_INIT_STATE:
      return restoreInitState(state);

    case ActionTypes.INSERT_TEMPLATE_DATA:
      return insertTemplateDate(state, action);

    default: {
      return state;
    }
  }
}

function receiveStructureList(state, action) {
  let { structureList } = action;
  if (!structureList || !structureList.length) {
    structureList = [];
  }
  const newState = structureList.reduce(
    (acc, cur) => {
      const { groupSecernId, parentGroupSecernId } = cur;
      acc.structures.bySecernId[groupSecernId] = cur;
      acc.structures.allSecernIds.push(groupSecernId);
      return acc;
    },
    { structures: { bySecernId: {}, allSecernIds: [] } },
  );

  return { ...state, ...newState, groupList: structureList };
}

function resetInitData(state) {
  const editingUser = {};
  const checkedUser = {
    bySecernId: {},
    allSecernIds: [],
  };
  const {
    searchUserResult,
    searchUserCondition,
    storeSearchUserCondition,
    checkedUserOnPage,
    allUserByEmail,
    selectedGroupList,
    courseName,
    groupList,
    recordNum,
  } = INITIAL_STATE;
  const isUsedTemplate = 0;
  return {
    ...state,
    searchUserResult,
    searchUserCondition,
    storeSearchUserCondition,
    editingUser,
    checkedUser,
    checkedUserOnPage,
    isUsedTemplate,
    allUserByEmail,
    selectedGroupList,
    courseName,
    groupList,
    recordNum,
  };
}

function resetSearchUserData(state) {
  const { allUserAttribute, allUserGroupRelation, allGroupRelation, allUserList } = INITIAL_STATE;
  const storedUserList = {
    bySecernId: {},
    allSecernIds: [],
  };
  return {
    ...state,
    allUserAttribute,
    allUserGroupRelation,
    allGroupRelation,
    allUserList,
    storedUserList,
  };
}

function resetSearchUserCondition(state) {
  const { selectedGroupList, searchUserCondition } = INITIAL_STATE;
  return {
    ...state,
    selectedGroupList,
    searchUserCondition,
  };
}

function receiveUserSearchUserResult(state, action) {
  const { startPosition, recordNum, userList } = action;
  const { checkedUser } = state;
  const checkedUserOnPage = {
    bySecernId: {},
    allSecernIds: [],
  };
  const searchUserResult = userList.reduce(
    (acc, cur) => {
      const { userSecernId } = cur;
      acc.bySecernId[userSecernId] = cur;
      acc.allSecernIds.push(userSecernId);
      if (checkedUser && checkedUser.bySecernId) {
        if (checkedUser.bySecernId[userSecernId]) {
          checkedUserOnPage.allSecernIds.push(userSecernId);
          checkedUserOnPage.bySecernId[userSecernId] = cur;
        }
      }
      return acc;
    },
    { startPosition, searched: true, recordNum, bySecernId: {}, allSecernIds: [] },
  );
  return {
    ...state,
    searchUserResult,
    checkedUserOnPage,
  };
}

function receiveAllUserSearchUserResult(state, action) {
  const { recordNum, userList, userAttributeSearchText } = action;
  const storedUserList = { ...state.storedUserList };
  userList.reduce(
    (acc, cur) => {
      const { userSecernId } = cur;
      const posInList = storedUserList.allSecernIds.indexOf(userSecernId);
      if (posInList === -1) {
        storedUserList.allSecernIds.push(userSecernId);
      }
      if (!storedUserList.bySecernId[userSecernId]) {
        storedUserList.bySecernId[userSecernId] = cur;
      }
    },
    { bySecernId: {}, allSecernIds: [] },
  );
  if (userAttributeSearchText) {
    return {
      ...state,
      storedUserList,
      recordNum,
    };
  }
  return {
    ...state,
    recordNum,
  };
}

function checkAllUser(state, action) {
  const storedUserList = { ...state.storedUserList };
  const storeSearchUserCondition = { ...state.storeSearchUserCondition };
  const searchUserCondition = { ...state.searchUserCondition };
  let checkedUser = { ...state.checkedUser };
  const searchUserResult = storedUserList.allSecernIds.reduce((acc, userSecernId, index) => {
    if (index < RETURN_MAX_NUM) {
      acc.allSecernIds.push(userSecernId);
      acc.bySecernId[userSecernId] = storedUserList.bySecernId[userSecernId];
    }
    return acc;
  }, { startPosition: 0, recordNum: storedUserList.allSecernIds.length, allSecernIds: [], bySecernId: {} });

  const userHasEmailList = storedUserList.allSecernIds.reduce((acc, userSecernId, index) => {
    if (
      storedUserList.bySecernId[userSecernId] &&
      storedUserList.bySecernId[userSecernId].mailAddress &&
      validEmail(storedUserList.bySecernId[userSecernId].mailAddress)
    ) {
      acc.allSecernIds.push(userSecernId);
      acc.bySecernId[userSecernId] = storedUserList.bySecernId[userSecernId];
    }
    return acc;
  }, { allSecernIds: [], bySecernId: {} });

  // Compare array
  const isSame = JSON.stringify(storeSearchUserCondition) === JSON.stringify(searchUserCondition);

  // Judge data there is change to check all or not
  const isCheckAll = checkedUser.allSecernIds.length !== userHasEmailList.allSecernIds.length || !isSame;

  if (isCheckAll) {
    // Add all user
    checkedUser = { allSecernIds: [], bySecernId: {} }; // Reset to empty

    userHasEmailList.allSecernIds.forEach((userSecernId) => {
      checkedUser.allSecernIds.unshift(userSecernId);
      checkedUser.bySecernId[userSecernId] = userHasEmailList.bySecernId[userSecernId];
    });
  } else {
    // Remove all user
    checkedUser = { allSecernIds: [], bySecernId: {} };
  }

  return {
    ...state,
    storedUserList,
    searchUserResult,
    checkedUser,
    storeSearchUserCondition: searchUserCondition,
  };
}

function addRemoveUser(state, action) {
  const { userSecernId } = action;
  const checkedUser = { ...state.checkedUser };
  const { searchUserResult, checkedUserOnPage } = state;
  if (searchUserResult
    && searchUserResult.allSecernIds
    && searchUserResult.allSecernIds.indexOf(userSecernId) > -1) {
    const posInList = checkedUser.allSecernIds.indexOf(userSecernId);
    if (posInList === -1) {
      checkedUser.allSecernIds.unshift(userSecernId);
    } else {
      checkedUser.allSecernIds.splice(posInList, 1);
    }
    if (checkedUser.bySecernId[userSecernId]) {
      delete checkedUser.bySecernId[userSecernId];
    } else {
      checkedUser.bySecernId[userSecernId] = searchUserResult.bySecernId[userSecernId];
    }
    const posInCheckedUserOnPage = checkedUserOnPage.allSecernIds.indexOf(userSecernId);
    if (posInCheckedUserOnPage === -1) {
      checkedUserOnPage.allSecernIds.unshift(userSecernId);
    } else {
      checkedUserOnPage.allSecernIds.splice(posInCheckedUserOnPage, 1);
    }
    if (checkedUserOnPage.bySecernId[userSecernId]) {
      delete checkedUserOnPage.bySecernId[userSecernId];
    } else {
      checkedUserOnPage.bySecernId[userSecernId] = searchUserResult.bySecernId[userSecernId];
    }
  }

  return {
    ...state,
    checkedUser,
  };
}

function addSelectedUser(state, action) {
  const { checkedUser } = state;
  const editingUser = { ...state.editingUser };
  checkedUser.allSecernIds.reduce((acc, userSecernId, index) => {
    if (!checkedUser.bySecernId || !checkedUser.bySecernId[userSecernId]) {
      return acc;
    }
    let addNew = false;
    if (!editingUser[userSecernId]) {
      addNew = true;
    } else {
      addNew = editingUser[userSecernId].addNew;
    }
    const relationInfo = editingUser[userSecernId] || {
      userSecernId,
    };
    relationInfo.addNew = addNew;
    const user = checkedUser.bySecernId[userSecernId];
    if (user) {
      relationInfo.userName = user.userName;
      relationInfo.loginId = user.loginId;
      relationInfo.managementAuthoritySecernId = user.managementAuthoritySecernId;
      relationInfo.userType = user.userType;
      relationInfo.groupName = user.groupName;
      relationInfo.mailAddress = user.mailAddress;
    }
    acc[userSecernId] = { ...relationInfo };
    editingUser[userSecernId] = acc[userSecernId];
    editingUser[userSecernId].index = index;
    return acc;
  }, {});

  return {
    ...state,
    editingUser,
  };
}

function removeUser(state, action) {
  const { userSecernId } = action;
  const checkedUser = { ...state.checkedUser };
  const editingUser = { ...state.editingUser };
  const checkedUserOnPage = { ...state.checkedUserOnPage };
  const index = checkedUser.allSecernIds.indexOf(userSecernId);
  if (index > -1) {
    checkedUser.allSecernIds.splice(index, 1);
  }
  if (checkedUser.bySecernId[userSecernId]) {
    delete checkedUser.bySecernId[userSecernId];
  }
  const pos = checkedUserOnPage.allSecernIds.indexOf(userSecernId);
  if (pos > -1) {
    checkedUserOnPage.allSecernIds.splice(pos, 1);
  }
  if (checkedUserOnPage.bySecernId[userSecernId]) {
    delete checkedUserOnPage.bySecernId[userSecernId];
  }
  delete editingUser[userSecernId];

  return {
    ...state,
    editingUser,
    checkedUser,
    checkedUserOnPage,
  };
}

function removeAllUser(state, action) {
  const { editingUser, checkedUser, checkedUserOnPage, editingCourse } = state;
  let bySecernId = {};
  let checkedUserRemove = {
    bySecernId: {},
    allSecernIds: [],
  };
  let checkedUserOnPageRemove = {
    bySecernId: {},
    allSecernIds: [],
  };

  bySecernId = { ...editingUser };
  const editingUserArray = Object.keys(bySecernId);
  editingUserArray.map((userSecernId) => {
    if (!bySecernId && !bySecernId[userSecernId]) {
      return null;
    }
    const {
      userType,
    } = bySecernId[userSecernId];
    delete bySecernId[userSecernId];
    checkedUserRemove = { ...checkedUser };
    const index = checkedUserRemove && checkedUserRemove.allSecernIds ?
    checkedUserRemove.allSecernIds.indexOf(userSecernId) : -1;
    if (index > -1) {
      checkedUserRemove.allSecernIds.splice(index, 1);
    }
    if (checkedUserRemove.bySecernId[userSecernId]) {
      delete checkedUserRemove.bySecernId[userSecernId];
    }
    checkedUserOnPageRemove = { ...checkedUserOnPage };
    const pos = checkedUserOnPageRemove && checkedUserOnPageRemove.allSecernIds ?
    checkedUserOnPageRemove.allSecernIds.indexOf(userSecernId) : -1;
    if (pos > -1) {
      checkedUserOnPageRemove.allSecernIds.splice(pos, 1);
    }
    if (checkedUserOnPageRemove.bySecernId[userSecernId]) {
      delete checkedUserOnPageRemove.bySecernId[userSecernId];
    }
  });

  return {
    ...state,
    editingUser: bySecernId,
    checkedUser: checkedUserRemove,
    checkedUserOnPage: checkedUserOnPageRemove,
  };
}

function receiveSearchUserCondition(state, action) {
  const { payload } = action;
  return {
    ...state,
    searchUserCondition: { ...state.searchUserCondition, ...payload },
  };
}

function addGroup(state, action) {
  const { groupList } = state;
  const selectedGroupList = [...state.selectedGroupList];
  const { group } = action;

  const groupIds = groupList.reduce((ids, cur) => {
    ids.push(cur.groupSecernId);
    return ids;
  }, []);

  const selectedGroupsIds = selectedGroupList.reduce((acc, cur) => {
    if (cur.groupSecernId) {
      acc.push(cur.groupSecernId);
    }
    return acc;
  }, []);

  for (let i = 0; i < group.length; i++) {
    if (groupIds.indexOf(group[i]) !== -1) {
      if (selectedGroupsIds.indexOf(group[i]) === -1) {
        const newGroup = {
          groupSecernId: group[i],
        };
        selectedGroupList.unshift(newGroup);
      }
    }
  }

  return {
    ...state,
    selectedGroupList,
  };
}

function removeGroup(state, action) {
  const selectedGroupList = [...state.selectedGroupList];
  const { index } = action;
  selectedGroupList.splice(index, 1);

  return {
    ...state,
    selectedGroupList,
  };
}

function removeSelectedUser(state) {
  return {
    ...state,
  };
}

function getAllUserReceivedByEmail(state, action) {
  const allUserByEmailNew = [...state.allUserByEmail];
  const { recordNum, emailList, userList } = action;

  const selectedUserList = userList.reduce((acc, cur) => {
    const { userSecernId } = cur;
    acc[userSecernId] = cur;
    return acc;
  }, {});
  if (emailList) {
    emailList.reduce((acc, cur) => {
      if (cur && cur.receiverUserSecernId) {
        const userSecernId = cur.receiverUserSecernId;
        const pos = allUserByEmailNew.findIndex(e => e.receiverUserSecernId === userSecernId);
        if (pos < 0) {
          acc.push(initUserInfo(cur, selectedUserList[userSecernId]));
        }
      }
      return acc;
    }, allUserByEmailNew);
  }
  return {
    ...state,
    allUserByEmail: allUserByEmailNew,
    recordNum,
    userList,
  };
}

function initUserInfo(obj, objToAdd) {
  if (objToAdd) {
    obj.userSecernId = objToAdd.receiverUserSecernId;
    obj.loginId = objToAdd.loginId;
    obj.userName = objToAdd.receiverUserName;
    obj.groupName = objToAdd.receiverUserGroupNames;
    obj.mailAddress = objToAdd.mailAddress;
  }
  return obj;
}

function getAllUserAttributeReceived(state, action) {
  const allUserAttributeNew = [...state.allUserAttribute];
  const { data } = action;
  const { recordNum, userAttributeList } = data;
  if (userAttributeList) {
    userAttributeList.reduce((acc, cur) => {
      if (cur && cur.secernId) {
        if (!allUserAttributeNew[cur.secernId]) {
          acc.push(cur.secernId);
        }
      }
      return acc;
    }, allUserAttributeNew);
  }

  return {
    ...state,
    allUserAttribute: allUserAttributeNew,
    recordNum,
  };
}

function getAllUserGroupRelationReceived(state, action) {
  const allUserGroupRelationNew = [...state.allUserGroupRelation];
  const { data } = action;
  const { groupRelationList } = data;
  if (groupRelationList) {
    groupRelationList.reduce((acc, cur) => {
      if (cur && cur.userSecernId) {
        if (!allUserGroupRelationNew[cur.userSecernId]) {
          acc.push(cur.userSecernId);
        }
      }
      return acc;
    }, allUserGroupRelationNew);
  }
  return {
    ...state,
    allUserGroupRelation: allUserGroupRelationNew,
  };
}

function getAllGroupRelationReceived(state, action) {
  const allGroupRelationNew = [...state.allGroupRelation];
  const { data } = action;
  const { groupRelationList } = data;
  if (groupRelationList) {
    groupRelationList.reduce((acc, cur) => {
      if (cur && cur.groupSecernId) {
        if (!allGroupRelationNew[cur.groupSecernId]) {
          acc.push(cur);
        }
      }
      return acc;
    }, allGroupRelationNew);
  }
  return {
    ...state,
    allGroupRelation: allGroupRelationNew,
  };
}

function getAllUserListReceived(state, action) {
  const allUserListNew = [...state.allUserList];
  const { data } = action;
  const { userList } = data;
  if (userList) {
    userList.reduce((acc, cur) => {
      if (cur && cur.userSecernId) {
        if (!allUserListNew[cur.userSecernId]) {
          acc.push(cur);
        }
      }
      return acc;
    }, allUserListNew);
  }
  return {
    ...state,
    allUserList: allUserListNew,
  };
}

function addUserToListByEmail(state, action) {
  const { userListToAdd } = action;
  const editingUser = { ...state.editingUser };
  const checkedUser = { ...state.checkedUser };

  userListToAdd.reduce(
    (acc, cur, index) => {
      const { receiverUserSecernId } = cur;
      acc[receiverUserSecernId] = initUserInfo({}, cur);
      editingUser[receiverUserSecernId] = acc[receiverUserSecernId];
      editingUser[receiverUserSecernId].index = index;
      const posInList = checkedUser.allSecernIds.indexOf(receiverUserSecernId);
      if (posInList === -1) {
        checkedUser.allSecernIds.unshift(receiverUserSecernId);
      } else {
        checkedUser.allSecernIds.splice(posInList, 1);
      }
      if (checkedUser.bySecernId[receiverUserSecernId]) {
        delete checkedUser.bySecernId[receiverUserSecernId];
      } else {
        checkedUser.bySecernId[receiverUserSecernId] = initUserInfo({}, cur);
      }
      return acc;
    }, { bySecernId: {}, allSecernIds: [] });

  return {
    ...state,
    editingUser,
    checkedUser,
  };
}

function saveReceiver(state, action) {
  const { receiverSaveKey } = action;
  return {
    ...state,
    emailReceiverSaveKey: receiverSaveKey.emailReceiverSaveKey,
  };
}

function saveEmailReceiverSaveKey(state, action) {
  const { emailReceiverSaveKey } = action;
  return {
    ...state,
    emailReceiverSaveKey,
  };
}

function backupInitState(state) {
  const orgEditingUser = { ...state.editingUser };

  return {
    ...state,
    orgEditingUser,
  };
}

function restoreInitState(state) {
  const editingUser = { ...state.orgEditingUser };

  // Reset backup value to init value
  state.orgEditingUser = {};
  state.orgCheckedUser = {
    bySecernId: {},
    allSecernIds: [],
  };
  return {
    ...state,
    editingUser,
  };
}

function receiveUsersFromCourseHistory(state, action) {
  const { startPosition, recordNum, userList } = action;
  const checkedUser = { ...state.checkedUser };
  const editingUser = { ...state.editingUser };
  let userSecernIdList = [];

  userSecernIdList = userList.reduce((acc, cur) => {
    if (cur && cur.userSecernId) {
      acc.push(cur.userSecernId);
    }
    return acc;
  }, []);

  const searchUserResult = userList.reduce(
    (acc, cur) => {
      const { userSecernId } = cur;
      acc.bySecernId[userSecernId] = cur;
      acc.allSecernIds.push(userSecernId);
      return acc;
    },
    { startPosition, searched: true, recordNum, bySecernId: {}, allSecernIds: [] },
  );

  const isCheckAll = userSecernIdList.length === checkedUser.allSecernIds.length;

  userSecernIdList.forEach((userSecernId, index) => {
    const posInList = checkedUser.allSecernIds.indexOf(userSecernId);
    if (posInList === -1) {
      checkedUser.allSecernIds.unshift(userSecernId);
    } else if (isCheckAll) {
      checkedUser.allSecernIds.splice(posInList, 1);
    }
    if (checkedUser.bySecernId[userSecernId]) {
      delete checkedUser.bySecernId[userSecernId];
    } else {
      checkedUser.bySecernId[userSecernId] = searchUserResult.bySecernId[userSecernId];
    }
    editingUser[userSecernId] = searchUserResult.bySecernId[userSecernId];
    editingUser[userSecernId].index = index;
  });

  return {
    ...state,
    checkedUser,
    editingUser,
  };
}

function getEmailList(state, action) {
  const { resData } = action;
  const { recordNum, emailList } = resData;
  const receiveMails = emailList.reduce(
    (acc, cur) => {
      if (cur.emailSenderIdAuto) {
        acc.allMailIds.push(cur.emailSenderIdAuto);
        acc.byMailIds[cur.emailSenderIdAuto] = cur;
      }
      return acc;
    },
    {
      allMailIds: [],
      byMailIds: {},
    },
  );
  return {
    ...state,
    receiveMails,
    emailList,
    recordNum,
  };
}

function getEmailDetail(state, action) {
  const { emailInfo } = action;
  return {
    ...state,
    emailInfo,
  };
}

function insertTemplateDate(state, action) {
  const { isUsedTemplate, courseDetail } = action;
  const { courseName } = courseDetail;
  return {
    ...state,
    isUsedTemplate,
    courseName,
  };
}
